import * as React from 'react';
import { Alert, Box, Divider, Drawer, IconButton, List, ListItem, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAppDispatch } from '../../hooks';
import { removeFromFavorites } from '../../slices/favoriteSlice';
import { useTheme, useMediaQuery } from '@mui/material';

interface FavoriteDrawerProps {
  favDrawerOpen: boolean;
  handleFavDrawerToggle: () => void;
  favIds: number[];
}

const FavoriteDrawer: React.FC<FavoriteDrawerProps> = ({ favDrawerOpen, handleFavDrawerToggle, favIds }) => {
  const dispatch = useAppDispatch();
  const baseUrl = 'https://career.cmj.vc'
  const handleDelete = (id: number) => {
    dispatch(removeFromFavorites(id));
  };

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));

  const drawerWidth = isXs ? '100%' : isSm ? '75%' : isMd ? '50%' : 400;

  const renderLink = (id: number) => {
    return `${baseUrl}/jobs/${id}`;
  };

  return (
    <Drawer
      anchor="right"
      open={favDrawerOpen}
      onClose={handleFavDrawerToggle}
      sx={{
        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
      }}
    >
      <Box sx={{ textAlign: 'center', padding: 2 }}>
        <Typography variant="h6">Favorite Posts</Typography>
        <Divider />
        <List>
          {favIds.length > 0 ? (
            favIds.map((id) => (
              <ListItem
                key={id}
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 0 }}
              >
                <a href={renderLink(id)} target='_blank' rel='noopener noreferrer' style={{ cursor: 'pointer', color: 'inherit' }}>
                  {renderLink(id)}
                </a>
                <IconButton onClick={() => handleDelete(id)} color="error" edge="end">
                  <DeleteIcon />
                </IconButton>
              </ListItem>
            ))
          ) : (
            <ListItem>
              <Alert sx={{ width: '100%' }} variant="outlined" severity="warning">
                There are no favorite posts.
              </Alert>
            </ListItem>
          )}
        </List>
      </Box>
    </Drawer>
  );
};

export default FavoriteDrawer;
